"use client"
import React, { useState, useEffect } from 'react';


const BlackFridayPopup = ({imageUrl}) => {
     const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Show popup on page load
    setIsOpen(true);
  }, []);

  const closePopup = () => {
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="relative bg-white rounded-lg max-w-md w-full">
        <button
          className="absolute top-2 right-2 text-white text-xl font-bold"
          onClick={closePopup}
        >
          ×
        </button>
        <img src={imageUrl} alt="Promotion" className="rounded-b-lg w-full" />
      </div>
    </div>
  );
}
export default BlackFridayPopup;